<template>
  <v-flex>
    <div class="row">
      <div class="col-12 col-md-6">
        <v-card>
          <v-card-text>
            <p class="title px-3 mb-6">{{ brief.daily.date }}</p>
            <v-list-item>
              <v-list-item-subtitle class="title">今日銷量</v-list-item-subtitle>
              <v-list-item-title class="headline">{{ brief.daily.quantity }}</v-list-item-title>
            </v-list-item>
            <v-list-item>
              <v-list-item-subtitle class="title">今日總額</v-list-item-subtitle>
              <v-list-item-title class="headline">{{ brief.daily.total_amount }}</v-list-item-title>
            </v-list-item>
          </v-card-text>
        </v-card>
      </div>
      <div class="col-12 col-md-6">
        <v-card>
          <v-card-text>
            <p class="title px-3 mb-6">{{ brief.monthly.date }}</p>
            <v-list-item>
              <v-list-item-subtitle class="title">本月銷量</v-list-item-subtitle>
              <v-list-item-title class="headline">{{ brief.monthly.quantity }}</v-list-item-title>
            </v-list-item>
            <v-list-item>
              <v-list-item-subtitle class="title">本月總額</v-list-item-subtitle>
              <v-list-item-title class="headline">{{ brief.monthly.total_amount }}</v-list-item-title>
            </v-list-item>
          </v-card-text>
        </v-card>
      </div>

      <div class="col-12">
        <v-card>
          <div class="pa-3 pt-6">
            <v-btn
              @click="togglePaymentStats('daily')"
              :outlined="paymentStats.active !== paymentStats.daily"
              color="blue"
              class="mr-3"
            >今日</v-btn>
            <v-btn
              @click="togglePaymentStats('monthly')"
              :outlined="paymentStats.active !== paymentStats.monthly"
              color="blue"
            >本月</v-btn>
          </div>

          <v-card-text>
            <p class="title mb-6">{{ paymentStats.active.date }}</p>
            <div class="row">
              <div class="col-6 col-md-3 pa-0">
                <v-list-item>
                  <div class="col-12 col-md-10 offset-md-1 px-0 px-md-3">
                    <v-list-item-subtitle class="title">現金</v-list-item-subtitle>
                    <v-list-item-title
                      class="headline text-right"
                    >{{ paymentStats.active.cash_amount }}</v-list-item-title>
                  </div>
                </v-list-item>
              </div>
              <div class="col-6 col-md-3 pa-0">
                <v-list-item>
                  <div class="col-12 col-md-10 offset-md-1 px-0 px-md-3">
                    <v-list-item-subtitle class="title">悠遊卡</v-list-item-subtitle>
                    <v-list-item-title
                      class="headline text-right"
                    >{{ paymentStats.active.easy_card_amount }}</v-list-item-title>
                  </div>
                </v-list-item>
              </div>
              <div class="col-6 col-md-3 pa-0">
                <v-list-item>
                  <div class="col-12 col-md-10 offset-md-1 px-0 px-md-3">
                    <v-list-item-subtitle class="title">Linepay</v-list-item-subtitle>
                    <v-list-item-title
                      class="headline text-right"
                    >{{ paymentStats.active.linepay_amount }}</v-list-item-title>
                  </div>
                </v-list-item>
              </div>
              <div class="col-6 col-md-3 pa-0">
                <v-list-item>
                  <div class="col-12 col-md-10 offset-md-1 px-0 px-md-3">
                    <v-list-item-subtitle class="title">iCash</v-list-item-subtitle>
                    <v-list-item-title
                      class="headline text-right"
                    >{{ paymentStats.active.icash_amount }}</v-list-item-title>
                  </div>
                </v-list-item>
              </div>
              <div class="col-6 col-md-3 pa-0">
                <v-list-item>
                  <div class="col-12 col-md-10 offset-md-1 px-0 px-md-3">
                    <v-list-item-subtitle class="title">信用卡</v-list-item-subtitle>
                    <v-list-item-title
                      class="headline text-right"
                    >{{ paymentStats.active.credit_card_amount }}</v-list-item-title>
                  </div>
                </v-list-item>
              </div>
              <div class="col-6 col-md-3 pa-0">
                <v-list-item>
                  <div class="col-12 col-md-10 offset-md-1 px-0 px-md-3">
                    <v-list-item-subtitle class="title">一卡通</v-list-item-subtitle>
                    <v-list-item-title
                      class="headline text-right"
                    >{{ paymentStats.active.ipass_amount }}</v-list-item-title>
                  </div>
                </v-list-item>
              </div>
              <div class="col-6 col-md-3 pa-0">
                <v-list-item>
                  <div class="col-12 col-md-10 offset-md-1 px-0 px-md-3">
                    <v-list-item-subtitle class="title">街口支付</v-list-item-subtitle>
                    <v-list-item-title
                      class="headline text-right"
                    >{{ paymentStats.active.jko_amount }}</v-list-item-title>
                  </div>
                </v-list-item>
              </div>
              <div class="col-6 col-md-3 pa-0">
                <v-list-item>
                  <div class="col-12 col-md-10 offset-md-1 px-0 px-md-3">
                    <v-list-item-subtitle class="title">其他</v-list-item-subtitle>
                    <v-list-item-title
                      class="headline text-right"
                    >{{ paymentStats.active.other_amount }}</v-list-item-title>
                  </div>
                </v-list-item>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </div>

      <div class="col-12">
        <v-card>
          <v-card-text>
            <v-form @submit.prevent="getComboChart">
              <div class="row align-center">
                <div class="col-auto">
                  <v-btn
                    @click="changeChartType(1);"
                    :outlined="form.type !== 1"
                    color="blue"
                    class="mr-3"
                  >年統計</v-btn>
                  <v-btn
                    @click="changeChartType(2);"
                    :outlined="form.type !== 2"
                    color="blue"
                    class="mr-3"
                  >月統計</v-btn>
                  <v-btn @click="changeChartType(3);" :outlined="form.type !== 3" color="blue">日統計</v-btn>
                </div>
                <div class="col-12 col-md">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="form.date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      @change="getComboChart"
                      v-model="form.date"
                      locale="zh-cn"
                      color="blue"
                    ></v-date-picker>
                  </v-menu>
                </div>
              </div>
            </v-form>

            <p class="title">{{ chartDate }}</p>
            <div id="chart"></div>
          </v-card-text>
        </v-card>
      </div>
    </div>
  </v-flex>
</template>



<script>
import { mapState, mapActions } from "vuex";

import saleApi from "@/api/sale";

export default {
  components: {},

  mixins: [],

  props: [],
  data() {
    return {
      brief: {
        daily: {},
        monthly: {}
      },
      paymentStats: {
        active: {},

        daily: {},
        monthly: {}
      },
      chartDate: "",

      form: {
        type: 2,
        date: new Date().toLocaleString("sv-SE").slice(0, 10)
      }
    };
  },

  computed: {},
  watch: {},
  methods: {
    togglePaymentStats(type) {
      this.paymentStats.active = this.paymentStats[type];
    },

    getComboChart() {
      saleApi
        .getComboChart(this.form.type, this.form.date.replace(/-/g, ""))
        .then(res => {
          this.chartDate = res.date;

          // NOTE: Google chart bug：值都是 0 的話，會畫出 -1 0 1 三條線，只好強置設個 max
          let max;
          const yMax = res.chart_data
            .map(val => {
              return val[1];
            })
            .concat(
              res.chart_data.map(val => {
                return val[2];
              })
            )
            .sort((a, b) => {
              return a - b;
            })
            .pop();

          if (!yMax) {
            max = 10;
          }

          const data = google.visualization.arrayToDataTable([
            ["日期", "總額（元）", "銷量（件）"],
            ...res.chart_data
          ]);
          const options = {
            height: 330,
            series: {
              0: {
                type: "line",
                targetAxisIndex: 0,
                color: "#ffc107"
              },
              1: {
                type: "bars",
                targetAxisIndex: 1,
                color: "#8d6e63"
              }
            },
            vAxis: {
              viewWindowMode: "explicit",
              viewWindow: {
                min: 0,
                max: max
              }
            }
          };

          const googleChart = new google.visualization.LineChart(
            document.getElementById("chart")
          );

          googleChart.draw(data, options);
        })
        .catch(err => {});
    },
    changeChartType(type) {
      this.form.type = type;

      this.getComboChart();
    }
  },

  mounted() {
    saleApi
      .getBrief()
      .then(res => {
        this.brief.daily = res.daily_brief;
        this.brief.monthly = res.monthly_brief;
      })
      .catch(err => {});

    saleApi
      .getPaymentStats()
      .then(res => {
        this.paymentStats.daily = res.daily_brief;
        this.paymentStats.monthly = res.monthly_brief;

        this.paymentStats.active = this.paymentStats.daily;
      })
      .catch(err => {});

    this.getComboChart();
  }
};
</script>

<style lang="scss" scoped>
</style>
